export function adaptiveSwiper(
  Swiper,
  { swiperElement, settings, mediaQuery }
) {
  let swiperInstance = null

  const enableSwiper = function () {
    swiperInstance = new Swiper(swiperElement, settings)
  }

  const breakpoint = window.matchMedia(mediaQuery)
  const breakpointChecker = function () {
    if (breakpoint.matches === true) {
      if (swiperInstance !== null) swiperInstance.destroy(true, true)
      return
    } else if (breakpoint.matches === false) {
      return enableSwiper()
    }
  }

  if (breakpoint.addEventListener) {
    breakpoint.addEventListener('change', breakpointChecker)
  } else if (breakpoint.addListener) {
    breakpoint.addListener(breakpointChecker)
  }
  breakpointChecker()
}
